import * as React from 'react';
import { ValidationLevel, ValidationProps } from 'ui';
import { LoadOptions, RequestApiMethod } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ReferenceCodeCategoryProps } from 'app/area/codetable/item/code-pickers/types';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { CodeActionType } from 'app/area/codetable/item/types';
import { endpoints } from 'app/area/codetable/item/endpoints';
import { isCheckBoxReferenceType } from 'app/area/codetable/item/screen-renderer/screen-pickers/reference/helpers';
import { referenceTypeId } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';

export const ReferenceCodeCategory = ({ metadata, codeItem, onChange, loadOptions, fetchingParentCategory,
  options, translation, validation, readOnly, actionType }: ReferenceCodeCategoryProps) => {

  if (!metadata || !metadata.codetableCategory || !isDefinedIncludingZero(metadata.codetableCategory.id)) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id,
      endpoints.optionsCollectionSearch(referenceTypeId),
      {
        ...loadOptionsParams,
        requestApiMethod: RequestApiMethod.post,
        ...{ displayNotSelected: false },
        ...{ apiVersion: '3.0' }
      }, { limitFieldsTo: [CodeFieldWireKey.code] });
  };

  const codeOptions = (!!options.category && options.category.codes || []) as CodeComplexValue<number>[];

  const isCodeAdding = codeItem && !isDefinedIncludingZero(codeItem.id);

  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const isCategoryReadOnly = fetchingParentCategory || (!isCodeDuplicating && (isCodeEditing || readOnly));

  const showWarningWhenEditing = isCodeEditing && !(codeItem.checkedCode && codeItem.uncheckedCode);

  const disabledCategoryValidation: ValidationProps = !!codeItem && isCheckBoxReferenceType(codeItem)
    && (isCodeAdding || isCodeDuplicating || showWarningWhenEditing) && !isCategoryReadOnly ?
    {
      level: ValidationLevel.warning, messages: [{
        level: ValidationLevel.warning,
        message: translation.reference_type_checkbox_info_text
      }]
    } : getDisabledValidation(codeItem.category?.disabled, translation.selected_value_disabled);

  const categoryValidation = !!validation && !!validation.category ? validation.category : undefined;
  const finalValidation = { ...categoryValidation, ...disabledCategoryValidation };

  return (
    <CodeSinglePicker
      id="category"
      label={metadata.codetableCategory.label ?? translation?.reference_type}
      valueItem={codeItem && codeItem.category}
      searchRequired={metadata.codetableCategory.id && metadata.codetableCategory.searchRequired}
      required={!isCategoryReadOnly}
      options={codeOptions}
      fetchingOptions={options.category && options.category.fetching}
      showSpinnerLabel={fetchingParentCategory}
      validation={finalValidation}
      translation={translation}

      onLoadOptions={onLoadOptions}
      onChange={onChange}
      readOnly={isCategoryReadOnly}
      enableMultilineValidation={true}
    />
  );
};
